import { LegalShell } from "@/components/sections/legal-shell";
import { Seo } from "@/components/seo/seo";
import { useSiteContent } from "@/config/use-site-content";
import { useLocale } from "@/i18n/locale-context";

export function LegalPage(): JSX.Element {
  const { locale } = useLocale();
  const content = useSiteContent();
  const legalContent = content.legal ?? {
    sections: [
      {
        body: [content.site.description],
        title: "Professional Portfolio",
      },
    ],
    updatedAt: "2026-05-01",
  };

  return (
    <>
      <Seo
        description={content.site.description}
        locale={locale}
        pathWithoutLocale="/legal"
        title="Legal"
      />
      <LegalShell content={legalContent} />
    </>
  );
}
